import { getTargetLanguageFromPair } from './utils/languagePairs';

// voiceConfig.ts

export interface VoiceMappings {
  [voiceId: string]: string;
}

export interface LanguageVoiceMappings {
  [language: string]: VoiceMappings;
}

export const voiceNamesByLanguage: LanguageVoiceMappings = {
  English: {
    // OpenAI voices
    'alloy': 'Amber Reyes',
    'ballad': 'Blake Morgan',
    'coral': 'Chloe Costa',
    'nova': 'Nora Lin',
    'sage': 'Sarah Weber',
    'shimmer': 'Sophia Navarro',
    'ash': 'Atlas Vega',
    'echo': 'Ethan Novak',
    'fable': 'Flynn Romano',
    'onyx': 'Oliver Santos',
    'verse': 'Victor Park',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Williams',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Thompson',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Johnson',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Davis',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Brown',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Wilson',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Miller',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily Anderson',
    'SAz9YHcvj6GT2YYXdXww': 'River Taylor',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Mitchell',
    'JBFqnCBsd6RMkjVDRZzb': 'George Hamilton',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Stone',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Parker',
    'bIHbv24MWmeRgasZH58o': 'Will Cooper',
    'cjVigY5qzO86Huf0OWal': 'Eric Martinez',
    'iP95p4xoKVk53GoZ742B': 'Chris Bennett',
    'nPczCjzI2devNBz1zQrb': 'Brian Foster',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Clarke',
    'pqHfZKP75CvOlQylNhV4': 'Bill Harrison',
  },
  'British English': {
    // OpenAI voices
    'alloy': 'Amelia Bennett',
    'ballad': 'Benjamin Clarke',
    'coral': 'Charlotte Wilson',
    'nova': 'Natalie Thompson',
    'sage': 'Sophie Taylor',
    'shimmer': 'Samantha Hughes',
    'ash': 'Alexander Edwards',
    'echo': 'Edward Mitchell',
    'fable': 'Frederick Palmer',
    'onyx': 'Oliver Wright',
    'verse': 'Victor Knight',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Whitfield',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Pemberton',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Ashford',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Fairfax',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Thornton',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Blackwood',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Hartwell',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily Westbrook',
    'SAz9YHcvj6GT2YYXdXww': 'River Kingsley',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Cromwell',
    'JBFqnCBsd6RMkjVDRZzb': 'George Pembroke',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Sinclair',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Worthington',
    'bIHbv24MWmeRgasZH58o': 'Will Harrington',
    'cjVigY5qzO86Huf0OWal': 'Eric Beaumont',
    'iP95p4xoKVk53GoZ742B': 'Chris Ashworth',
    'nPczCjzI2devNBz1zQrb': 'Brian Kensington',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Blackthorne',
    'pqHfZKP75CvOlQylNhV4': 'Bill Whitmore',
  },
  German: {
    // OpenAI voices
    'alloy': 'Amelia Richter',
    'ballad': 'Bastian Müller',
    'coral': 'Charlotte Krause',
    'nova': 'Nina Lehmann',
    'sage': 'Sofia Wagner',
    'shimmer': 'Sabine Müller',
    'ash': 'Alexander Schmidt',
    'echo': 'Erik Becker',
    'fable': 'Felix Hoffmann',
    'onyx': 'Otto Weber',
    'verse': 'Viktor Schulz',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Zimmermann',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Brenner',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Hartmann',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Schwarz',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Kellner',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Steinberg',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Neumann',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily Berger',
    'SAz9YHcvj6GT2YYXdXww': 'River Winkler',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Hoffmann',
    'JBFqnCBsd6RMkjVDRZzb': 'Georg von Habsburg',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Steinmann',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Kaufmann',
    'bIHbv24MWmeRgasZH58o': 'Will Bachmann',
    'cjVigY5qzO86Huf0OWal': 'Erik Zimmermann',
    'iP95p4xoKVk53GoZ742B': 'Christoph Weber',
    'nPczCjzI2devNBz1zQrb': 'Brian Krüger',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Rothschild',
    'pqHfZKP75CvOlQylNhV4': 'Wilhelm Koehler',
  },
  French: {
    // OpenAI voices
    'alloy': 'Amélie Rousseau',
    'ballad': 'Baptiste Moreau',
    'coral': 'Camille Dubois',
    'nova': 'Nicole Laurent',
    'sage': 'Sophie Lefebvre',
    'shimmer': 'Simone Dupont',
    'ash': 'Antoine Mercier',
    'echo': 'Étienne Bernard',
    'fable': 'François Petit',
    'onyx': 'Olivier Martin',
    'verse': 'Vincent Leroy',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Beaumont',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Girard',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Moreau',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Dubois',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Fontaine',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Leclerc',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Deschamps',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily Delacroix',
    'SAz9YHcvj6GT2YYXdXww': 'River Montclair',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Blanchard',
    'JBFqnCBsd6RMkjVDRZzb': 'Georges de Montpensier',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Rousseau',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Therrien',
    'bIHbv24MWmeRgasZH58o': 'Will Charlemagne',
    'cjVigY5qzO86Huf0OWal': 'Éric Champagne',
    'iP95p4xoKVk53GoZ742B': 'Christophe Beaulieu',
    'nPczCjzI2devNBz1zQrb': 'Brian Marchand',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Dufresne',
    'pqHfZKP75CvOlQylNhV4': 'Guillaume Tremblay',
  },
  Italian: {
    // OpenAI voices
    'alloy': 'Alessia Romano',
    'ballad': 'Bruno Bianchi',
    'coral': 'Chiara Ricci',
    'nova': 'Nicoletta Longo',
    'sage': 'Sofia Esposito',
    'shimmer': 'Serena Conti',
    'ash': 'Antonio Rossi',
    'echo': 'Enzo Ferrari',
    'fable': 'Francesco Russo',
    'onyx': 'Orazio Rizzo',
    'verse': 'Vittorio Marini',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Benedetti',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Lombardi',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Rossini',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Bellacorte',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Torretti',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Monteverdi',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Fiore',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily Santangelo',
    'SAz9YHcvj6GT2YYXdXww': 'River Bonaccorso',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Bianchi',
    'JBFqnCBsd6RMkjVDRZzb': 'Giorgio di Medici',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Rossetti',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Castellano',
    'bIHbv24MWmeRgasZH58o': 'Guglielmo Ferretti',
    'cjVigY5qzO86Huf0OWal': 'Erico Marinelli',
    'iP95p4xoKVk53GoZ742B': 'Cristoforo Benedetto',
    'nPczCjzI2devNBz1zQrb': 'Briano Torriani',
    'onwK4e9ZLuTAKqWW03F9': 'Daniele Borgogno',
    'pqHfZKP75CvOlQylNhV4': 'Guglielmo Vitale',
  },
  Dutch: {
    // OpenAI voices
    'alloy': 'Annemieke de Vries',
    'ballad': 'Bram Bakker',
    'coral': 'Clara Visser',
    'nova': 'Nienke Jansen',
    'sage': 'Sanne de Boer',
    'shimmer': 'Sophie van Dijk',
    'ash': 'Abel Smit',
    'echo': 'Evert Meijer',
    'fable': 'Floris Bos',
    'onyx': 'Oscar de Groot',
    'verse': 'Vincent Vos',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria van Bergen',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah de Wit',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Vermeer',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte van Houten',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Hendrikx',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda van der Berg',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Koning',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily Boersma',
    'SAz9YHcvj6GT2YYXdXww': 'River van Dijk',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Dekker',
    'JBFqnCBsd6RMkjVDRZzb': 'George van Oranje',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Janssen',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam de Jong',
    'bIHbv24MWmeRgasZH58o': 'Willem van Hoorn',
    'cjVigY5qzO86Huf0OWal': 'Erik Verhagen',
    'iP95p4xoKVk53GoZ742B': 'Christiaan Peters',
    'nPczCjzI2devNBz1zQrb': 'Brian van Eijk',
    'onwK4e9ZLuTAKqWW03F9': 'Daniël Hendrik',
    'pqHfZKP75CvOlQylNhV4': 'Willem Breugel',
  },
  'European Portuguese': {
    // OpenAI voices
    'alloy': 'Amália Ribeiro',
    'ballad': 'Bruno Barros',
    'coral': 'Catarina Oliveira',
    'nova': 'Nádia Santos',
    'sage': 'Sofia Almeida',
    'shimmer': 'Susana Costa',
    'ash': 'António Silva',
    'echo': 'Eduardo Pereira',
    'fable': 'Francisco Sousa',
    'onyx': 'Óscar Rodrigues',
    'verse': 'Vasco Martins',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Ária Monteiro',
    'EXAVITQu4vr4xnSDxMaL': 'Sara Carvalho',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Fernandes',
    'XB0fDUnXU5powFXDhCwa': 'Carlota Pereira',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Correia',
    'XrExE9yKIg1WjnnlVkGX': 'Matilde Tavares',
    'cgSgspJ2msm6clMCkdW9': 'Jéssica Gonçalves',
    'pFZP5JQG7iQjIQuC4Bku': 'Lídia Mendes',
    'SAz9YHcvj6GT2YYXdXww': 'River Castelo',
    'IKne3meq5aSn9XLyUdCD': 'Carlos Ferreira',
    'JBFqnCBsd6RMkjVDRZzb': 'Jorge de Bragança',
    'N2lVS1w4EtoT3dr4eOWO': 'Calisto Ramos',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Brandão',
    'bIHbv24MWmeRgasZH58o': 'Guilherme Machado',
    'cjVigY5qzO86Huf0OWal': 'Érico Figueiredo',
    'iP95p4xoKVk53GoZ742B': 'Cristóvão Neves',
    'nPczCjzI2devNBz1zQrb': 'Brício Lopes',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Henriques',
    'pqHfZKP75CvOlQylNhV4': 'Guilherme Viana',
  },
  'Brazilian Portuguese': {
    // OpenAI voices
    'alloy': 'Amanda Santos',
    'ballad': 'Bruno Costa',
    'coral': 'Carolina Lima',
    'nova': 'Natália Oliveira',
    'sage': 'Sofia Alves',
    'shimmer': 'Sueli Ferreira',
    'ash': 'André Silva',
    'echo': 'Eduardo Souza',
    'fable': 'Felipe Rodrigues',
    'onyx': 'Otávio Pereira',
    'verse': 'Vinícius Martins',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Machado',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Barbosa',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Fernandes',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Moreira',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Cardoso',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Nascimento',
    'cgSgspJ2msm6clMCkdW9': 'Jéssica Ribeiro',
    'pFZP5JQG7iQjIQuC4Bku': 'Lívia Campos',
    'SAz9YHcvj6GT2YYXdXww': 'River Monteiro',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Carvalho',
    'JBFqnCBsd6RMkjVDRZzb': 'Jorge Mendonça',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Medeiros',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Castilho',
    'bIHbv24MWmeRgasZH58o': 'Guilherme Azevedo',
    'cjVigY5qzO86Huf0OWal': 'Érico Nogueira',
    'iP95p4xoKVk53GoZ742B': 'Cristiano Batista',
    'nPczCjzI2devNBz1zQrb': 'Brian Figueiredo',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Cordeiro',
    'pqHfZKP75CvOlQylNhV4': 'Guilherme Teixeira',
  },
  'European Spanish': {
    // OpenAI voices
    'alloy': 'Adriana García',
    'ballad': 'Benito Blanco',
    'coral': 'Carmen Ruiz',
    'nova': 'Nuria Fernández',
    'sage': 'Sofía López',
    'shimmer': 'Silvia Martínez',
    'ash': 'Alejandro Sánchez',
    'echo': 'Eduardo Vega',
    'fable': 'Fernando Jiménez',
    'onyx': 'Óscar Mendoza',
    'verse': 'Vicente Navarro',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Velázquez',
    'EXAVITQu4vr4xnSDxMaL': 'Sara Fernández',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Castillo',
    'XB0fDUnXU5powFXDhCwa': 'Carlota Moreno',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alicia de la Torre',
    'XrExE9yKIg1WjnnlVkGX': 'Matilde Herrera',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Domínguez',
    'pFZP5JQG7iQjIQuC4Bku': 'Liliana Guerrero',
    'SAz9YHcvj6GT2YYXdXww': 'River Mendoza',
    'IKne3meq5aSn9XLyUdCD': 'Carlos Jiménez',
    'JBFqnCBsd6RMkjVDRZzb': 'Jorge de Bourbon',
    'N2lVS1w4EtoT3dr4eOWO': 'Calixto Ramírez',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Cervantes',
    'bIHbv24MWmeRgasZH58o': 'Guillermo Vásquez',
    'cjVigY5qzO86Huf0OWal': 'Érico Delgado',
    'iP95p4xoKVk53GoZ742B': 'Cristóbal Montoya',
    'nPczCjzI2devNBz1zQrb': 'Brian Serrano',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Suárez',
    'pqHfZKP75CvOlQylNhV4': 'Guillermo Álvarez',
  },
  'Latin American Spanish': {
    // OpenAI voices
    'alloy': 'Alejandra Reyes',
    'ballad': 'Bernardo Blanco',
    'coral': 'Carmela Fuentes',
    'nova': 'Natalia Cruz',
    'sage': 'Sofía Herrera',
    'shimmer': 'Silvia Vargas',
    'ash': 'Andrés Torres',
    'echo': 'Emilio Vásquez',
    'fable': 'Francisco Mendoza',
    'onyx': 'Oscar Ramírez',
    'verse': 'Vicente Gómez',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Montalvo',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Herrera',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Vega',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Sandoval',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alicia Romero',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Guerrero',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Morales',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily Contreras',
    'SAz9YHcvj6GT2YYXdXww': 'River Espinoza',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Torres',
    'JBFqnCBsd6RMkjVDRZzb': 'Jorge Villareal',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Navarro',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Delgado',
    'bIHbv24MWmeRgasZH58o': 'Guillermo Ramos',
    'cjVigY5qzO86Huf0OWal': 'Érico Salinas',
    'iP95p4xoKVk53GoZ742B': 'Cristóbal Mendez',
    'nPczCjzI2devNBz1zQrb': 'Brian Castañeda',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Figueroa',
    'pqHfZKP75CvOlQylNhV4': 'Guillermo Santana',
  },
  'Traditional Chinese': {
    // OpenAI voices
    'alloy': 'Amy Chen',
    'ballad': 'Blake Wang',
    'coral': 'Cora Lin',
    'nova': 'Nova Liu',
    'sage': 'Sage Zhang',
    'shimmer': 'Sherry Yang',
    'ash': 'Ash Li',
    'echo': 'Echo Wu',
    'fable': 'Felix Huang',
    'onyx': 'Oscar Zhou',
    'verse': 'Victor Zhao',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Hsu',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Chang',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Tsai',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Lee',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Cheng',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Ma',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Yu',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily Kuo',
    'SAz9YHcvj6GT2YYXdXww': 'River Jiang',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Xu',
    'JBFqnCBsd6RMkjVDRZzb': 'George Tang',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Lu',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Feng',
    'bIHbv24MWmeRgasZH58o': 'Will Hong',
    'cjVigY5qzO86Huf0OWal': 'Eric Yeh',
    'iP95p4xoKVk53GoZ742B': 'Chris Pan',
    'nPczCjzI2devNBz1zQrb': 'Brian Shih',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Lai',
    'pqHfZKP75CvOlQylNhV4': 'Bill Tseng',
  },
  'Simplified Chinese': {
    // OpenAI voices
    'alloy': 'Amy Chen',
    'ballad': 'Blake Wang',
    'coral': 'Cora Lin',
    'nova': 'Nova Liu',
    'sage': 'Sage Zhang',
    'shimmer': 'Sherry Yang',
    'ash': 'Ash Li',
    'echo': 'Echo Wu',
    'fable': 'Felix Huang',
    'onyx': 'Oscar Zhou',
    'verse': 'Victor Zhao',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Sun',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Wei',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Qian',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Zhu',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Song',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Gao',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Hu',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily He',
    'SAz9YHcvj6GT2YYXdXww': 'River Luo',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Xie',
    'JBFqnCBsd6RMkjVDRZzb': 'George Deng',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Han',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Cao',
    'bIHbv24MWmeRgasZH58o': 'Will Xu',
    'cjVigY5qzO86Huf0OWal': 'Eric Guo',
    'iP95p4xoKVk53GoZ742B': 'Chris Shen',
    'nPczCjzI2devNBz1zQrb': 'Brian Ren',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Bai',
    'pqHfZKP75CvOlQylNhV4': 'Bill Ding',
  },
  Russian: {
    // OpenAI voices
    'alloy': 'Alena Sorokina',
    'ballad': 'Boris Mikhailov',
    'coral': 'Kristina Volkova',
    'nova': 'Nadezhda Petrova',
    'sage': 'Sofia Romanova',
    'shimmer': 'Svetlana Kozlova',
    'ash': 'Alexander Nikolaev',
    'echo': 'Egor Smirnov',
    'fable': 'Fyodor Ivanov',
    'onyx': 'Oleg Lebedev',
    'verse': 'Victor Morozov',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Belova',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Kuznetsova',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Sokolova',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Popova',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Vasileva',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Pavlova',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Semenova',
    'pFZP5JQG7iQjIQuC4Bku': 'Lilia Stepanova',
    'SAz9YHcvj6GT2YYXdXww': 'River Makarov',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Andreev',
    'JBFqnCBsd6RMkjVDRZzb': 'George Orlov',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Zhukov',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Zakharov',
    'bIHbv24MWmeRgasZH58o': 'William Fyodorov',
    'cjVigY5qzO86Huf0OWal': 'Eric Bogdanov',
    'iP95p4xoKVk53GoZ742B': 'Christopher Krylov',
    'nPczCjzI2devNBz1zQrb': 'Brian Vorobev',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Kiselev',
    'pqHfZKP75CvOlQylNhV4': 'Bill Gerasimov',
  },
  Thai: {
    // OpenAI voices
    'alloy': 'Amporn Sawan',
    'ballad': 'Boonlert Srisuk',
    'coral': 'Chalita Wong',
    'nova': 'Napa Chan',
    'sage': 'Sopha Thong',
    'shimmer': 'Siriporn Saeng',
    'ash': 'Akkaradech Pitak',
    'echo': 'Ekkachai Somboon',
    'fable': 'Faisai Ratana',
    'onyx': 'Opas Boonmee',
    'verse': 'Veera Saksri',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Mani',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Paisal',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Suksan',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Wichai',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Prapa',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Saithong',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Arun',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily Boonterm',
    'SAz9YHcvj6GT2YYXdXww': 'River Namjai',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Sapsin',
    'JBFqnCBsd6RMkjVDRZzb': 'George Pongpanit',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Tanakorn',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Suwan',
    'bIHbv24MWmeRgasZH58o': 'William Jitkorn',
    'cjVigY5qzO86Huf0OWal': 'Eric Chaiwat',
    'iP95p4xoKVk53GoZ742B': 'Chris Somsak',
    'nPczCjzI2devNBz1zQrb': 'Brian Pipat',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Worapong',
    'pqHfZKP75CvOlQylNhV4': 'Bill Ananda',
  },
  Hindi: {
    // OpenAI voices
    'alloy': 'Amrita Sharma',
    'ballad': 'Bharat Mishra',
    'coral': 'Chandra Gupta',
    'nova': 'Nita Verma',
    'sage': 'Sofia Patel',
    'shimmer': 'Simran Kapoor',
    'ash': 'Akshay Kumar',
    'echo': 'Ekansh Singh',
    'fable': 'Fahim Khan',
    'onyx': 'Om Prakash',
    'verse': 'Vikram Rathore',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Joshi',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Sharma',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Desai',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Mehta',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Patel',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Rai',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Khan',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily Chaudhary',
    'SAz9YHcvj6GT2YYXdXww': 'River Nair',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Bhatt',
    'JBFqnCBsd6RMkjVDRZzb': 'George Gupta',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Verma',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Singh',
    'bIHbv24MWmeRgasZH58o': 'Will Shukla',
    'cjVigY5qzO86Huf0OWal': 'Eric Jain',
    'iP95p4xoKVk53GoZ742B': 'Chris Kumar',
    'nPczCjzI2devNBz1zQrb': 'Brian Agarwal',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Reddy',
    'pqHfZKP75CvOlQylNhV4': 'Bill Gandhi',
  },
  Catalan: {
    // OpenAI voices
    'alloy': 'Anna Puig',
    'ballad': 'Bernat Ferrer',
    'coral': 'Carla Roca',
    'nova': 'Núria Martí',
    'sage': 'Sofia Vidal',
    'shimmer': 'Sílvia Serra',
    'ash': 'Arnau Soler',
    'echo': 'Eduard Pujol',
    'fable': 'Francesc Bosch',
    'onyx': 'Oriol Camps',
    'verse': 'Víctor Sala',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Ària Colom',
    'EXAVITQu4vr4xnSDxMaL': 'Sara Comas',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Vilaró',
    'XB0fDUnXU5powFXDhCwa': 'Carlota Prats',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alícia Torrent',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Casals',
    'cgSgspJ2msm6clMCkdW9': 'Jèssica Rovira',
    'pFZP5JQG7iQjIQuC4Bku': 'Lília Font',
    'SAz9YHcvj6GT2YYXdXww': 'River Montserrat',
    'IKne3meq5aSn9XLyUdCD': 'Carles Figueres',
    'JBFqnCBsd6RMkjVDRZzb': 'Jordi Pujades',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Sabater',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Domènech',
    'bIHbv24MWmeRgasZH58o': 'Guillem Queralt',
    'cjVigY5qzO86Huf0OWal': 'Èric Vendrell',
    'iP95p4xoKVk53GoZ742B': 'Cristòfol Miró',
    'nPczCjzI2devNBz1zQrb': 'Brian Castelló',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Barbera',
    'pqHfZKP75CvOlQylNhV4': 'Guillem Valldaura',
  },
  Polish: {
    // OpenAI voices
    'alloy': 'Anna Kowalska',
    'ballad': 'Bartosz Nowak',
    'coral': 'Celina Wiśniewska',
    'nova': 'Natalia Wójcik',
    'sage': 'Zofia Kamińska',
    'shimmer': 'Sylwia Lewandowska',
    'ash': 'Adam Zieliński',
    'echo': 'Edward Woźniak',
    'fable': 'Filip Szymański',
    'onyx': 'Oskar Dąbrowski',
    'verse': 'Wiktor Kozłowski',
    // ElevenLabs voices
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Kowalski',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alicja Nowak',
    'pFZP5JQG7iQjIQuC4Bku': 'Liliana Wiśniewska',
    '9BWtsMINqrJLrRacOk9x': 'Aria Mazur',
    'EXAVITQu4vr4xnSDxMaL': 'Sara Krawczyk',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Piotrowski',
    'XB0fDUnXU5powFXDhCwa': 'Charlotta Jabłoński',
    'XrExE9yKIg1WjnnlVkGX': 'Matylda Kaczmarek',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Pawłowski',
    'SAz9YHcvj6GT2YYXdXww': 'River Górski',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Zając',
    'JBFqnCBsd6RMkjVDRZzb': 'Jerzy Król',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Michalski',
    'bIHbv24MWmeRgasZH58o': 'Wilhelm Wróbel',
    'cjVigY5qzO86Huf0OWal': 'Eryk Sikora',
    'iP95p4xoKVk53GoZ742B': 'Krzysztof Walczak',
    'nPczCjzI2devNBz1zQrb': 'Brian Baran',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Szewczyk',
    'pqHfZKP75CvOlQylNhV4': 'Wilhelm Rutkowski',
  },
  Ukrainian: {
    // OpenAI voices
    'alloy': 'Alina Kovalenko',
    'ballad': 'Bohdan Shevchenko',
    'coral': 'Christina Bondarenko',
    'nova': 'Nadia Tkachenko',
    'sage': 'Sofia Melnyk',
    'shimmer': 'Svitlana Kravchenko',
    'ash': 'Andrii Oliynyk',
    'echo': 'Yevhen Polishchuk',
    'fable': 'Fedir Savchenko',
    'onyx': 'Oleg Moroz',
    'verse': 'Viktor Lysenko',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Petrenko',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Honcharuk',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Vasylenko',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Romanenko',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Pavlenko',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Yakovenko',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Ponomarenko',
    'pFZP5JQG7iQjIQuC4Bku': 'Lilia Doroshenko',
    'SAz9YHcvj6GT2YYXdXww': 'River Lytvynenko',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Hrytsenko',
    'JBFqnCBsd6RMkjVDRZzb': 'George Zakharchenko',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Makovskyi',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Tymoshenko',
    'bIHbv24MWmeRgasZH58o': 'William Kuzmenko',
    'cjVigY5qzO86Huf0OWal': 'Eric Danyliuk',
    'iP95p4xoKVk53GoZ742B': 'Chris Ivanenko',
    'nPczCjzI2devNBz1zQrb': 'Brian Kovalchuk',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Semeniuk',
    'pqHfZKP75CvOlQylNhV4': 'Bill Andrienko',
  },
  Swedish: {
    // OpenAI voices
    'alloy': 'Anna Eriksson',
    'ballad': 'Björn Larsson',
    'coral': 'Cecilia Nilsson',
    'nova': 'Nora Andersson',
    'sage': 'Sofia Johansson',
    'shimmer': 'Signe Karlsson',
    'ash': 'Anders Pettersson',
    'echo': 'Erik Gustafsson',
    'fable': 'Fredrik Olsson',
    'onyx': 'Oscar Persson',
    'verse': 'Viktor Svensson',
    // ElevenLabs voices
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Lindqvist',
    'bIHbv24MWmeRgasZH58o': 'William Andersson',
    'iP95p4xoKVk53GoZ742B': 'Christian Johansson',
    '9BWtsMINqrJLrRacOk9x': 'Aria Bergström',
    'EXAVITQu4vr4xnSDxMaL': 'Sara Lindberg',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Magnusson',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Eklund',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Lundqvist',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Nordström',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily Bengtsson',
    'SAz9YHcvj6GT2YYXdXww': 'River Holmberg',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Samuelsson',
    'JBFqnCBsd6RMkjVDRZzb': 'Georg Lindgren',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Axelsson',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Lundgren',
    'cjVigY5qzO86Huf0OWal': 'Erik Engström',
    'nPczCjzI2devNBz1zQrb': 'Brian Björklund',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Forsberg',
    'pqHfZKP75CvOlQylNhV4': 'Vilhelm Sandberg',
  },
  Japanese: {
    // OpenAI voices
    'alloy': 'Ayumi Sato',
    'ballad': 'Bunpei Yamada',
    'coral': 'Chihiro Tanaka',
    'nova': 'Naomi Watanabe',
    'sage': 'Sakura Kobayashi',
    'shimmer': 'Sumiko Ito',
    'ash': 'Akira Suzuki',
    'echo': 'Eiji Takahashi',
    'fable': 'Fumio Nakamura',
    'onyx': 'Osamu Yoshida',
    'verse': 'Yuki Sasaki',
    // ElevenLabs voices
    '9BWtsMINqrJLrRacOk9x': 'Aria Kimura',
    'EXAVITQu4vr4xnSDxMaL': 'Sarah Hayashi',
    'FGY2WhTYpPnrIDTdsKH5': 'Laura Mori',
    'XB0fDUnXU5powFXDhCwa': 'Charlotte Fujiwara',
    'Xb7hH8MSUJpSbSDYk0k2': 'Alice Shimizu',
    'XrExE9yKIg1WjnnlVkGX': 'Matilda Okamoto',
    'cgSgspJ2msm6clMCkdW9': 'Jessica Yamaguchi',
    'pFZP5JQG7iQjIQuC4Bku': 'Lily Matsuda',
    'SAz9YHcvj6GT2YYXdXww': 'River Takeda',
    'IKne3meq5aSn9XLyUdCD': 'Charlie Kato',
    'JBFqnCBsd6RMkjVDRZzb': 'George Ishikawa',
    'N2lVS1w4EtoT3dr4eOWO': 'Callum Ogawa',
    'TX3LPaxmHKxFdv7VOQHJ': 'Liam Harada',
    'bIHbv24MWmeRgasZH58o': 'Will Miyamoto',
    'cjVigY5qzO86Huf0OWal': 'Eric Nakajima',
    'iP95p4xoKVk53GoZ742B': 'Chris Endo',
    'nPczCjzI2devNBz1zQrb': 'Brian Sakamoto',
    'onwK4e9ZLuTAKqWW03F9': 'Daniel Ueda',
    'pqHfZKP75CvOlQylNhV4': 'Bill Hashimoto',
  },  
};

// Helper function to get voice display name
export const getVoiceDisplayName = (voiceId: string | undefined, language?: string, bookLanguage?: string, selectedLanguage?: string): string => {
  if (!voiceId) return "Unknown";
  
  // Determine the target language for voice names
  let targetLanguage = bookLanguage || 'English'; // Default to book's original language
  
  if (selectedLanguage && selectedLanguage !== 'original') {
    targetLanguage = getTargetLanguageFromPair(selectedLanguage) || selectedLanguage;
  }
  
  // Override if language parameter is provided
  if (language) {
    targetLanguage = language;
  }
  
  // Get the voice names for the target language, fallback to English if not found
  const voiceNames = voiceNamesByLanguage[targetLanguage as keyof typeof voiceNamesByLanguage] || voiceNamesByLanguage.English;
  
  return voiceNames[voiceId as keyof typeof voiceNames] || voiceId;
};
